import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-soft">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 space-y-5">
          <Link to="/" className="flex items-center gap-3" aria-label="Startseite">
            <img src="/brand/logo-mark.png" alt="IT-Servicepoint Logo" className="h-12 w-auto" width="48" height="48" />
            <span className="font-display font-black text-xl text-ink">IT-Servicepoint</span>
          </Link>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary">{t.footer.tagline}</p>
          <p className="text-muted max-w-md leading-relaxed">
            Managed Security, Backup, Cloud-Hosting und IT-Beratung für den deutschen Mittelstand –
            zertifiziert, persönlich und made in Germany. Inhabergeführt aus Schenklengsfeld, Hessen.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-muted mb-5">{t.footer.services}</h4>
          <ul className="space-y-3 text-sm">
            <li><Link className="text-ink hover:text-primary transition-colors" to="/lokale-ki">{t.nav.local_ai || "Lokale KI"}</Link></li>
            <li><Link className="text-ink hover:text-primary transition-colors" to="/managed-security">{t.nav.managed_security}</Link></li>
            <li><Link className="text-ink hover:text-primary transition-colors" to="/managed-backup">{t.nav.managed_backup}</Link></li>
            <li><Link className="text-ink hover:text-primary transition-colors" to="/managed-server">{t.nav.managed_server}</Link></li>
            <li><Link className="text-ink hover:text-primary transition-colors" to="/schwachstellenmanagement">{t.nav.schwachstellen}</Link></li>
            <li><Link className="text-ink hover:text-primary transition-colors" to="/managed-wlan">{t.nav.managed_wlan}</Link></li>
            <li><Link className="text-ink hover:text-primary transition-colors" to="/ueberwachungskameras">{t.nav.cameras || "Überwachungskameras"}</Link></li>
            <li><Link className="text-ink hover:text-primary transition-colors" to="/webdesign">{t.nav.webdesign}</Link></li>
            <li><Link className="text-ink hover:text-primary transition-colors" to="/it-dienstleister" data-testid="footer-it-dienstleister">IT-Dienstleister & IT-Beratung</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4 space-y-5">
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-muted">{t.footer.contact}</h4>
          <ul className="space-y-3 text-sm text-ink">
            <li className="flex items-start gap-3"><MapPin size={16} className="text-primary mt-0.5 flex-shrink-0" /> <address className="not-italic">Im Wiesengrund 2A, 36277 Schenklengsfeld</address></li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-primary flex-shrink-0" /> <a href="tel:+4966299153890" className="hover:text-primary">+49 (0) 6629 9153890</a></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-primary flex-shrink-0" /> <a href="mailto:info@it-servicepoint.eu" className="hover:text-primary">info@it-servicepoint.eu</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-line bg-white/60">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs font-mono uppercase tracking-[0.2em] text-muted">
          <span>© {new Date().getFullYear()} IT-Servicepoint · {t.footer.copyright}</span>
          <div className="flex gap-5">
            <Link to="/impressum" className="hover:text-primary">{t.footer.impressum}</Link>
            <Link to="/datenschutz" className="hover:text-primary">{t.footer.datenschutz}</Link>
            <Link to="/admin/login" className="hover:text-primary" data-testid="admin-link-footer">{t.nav.admin}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
